import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BrowserRouter, Link, Route } from 'react-router-dom';
import { Button, Container, Icon, Menu, Sidebar } from 'semantic-ui-react';

import * as actions from '../actions';
import { Landing } from './Landing';
import { Header } from './Header';
import { Home } from './Home';
import { Saved } from './Saved';
import { Search } from './Search';

class App extends Component {
  state = { sidebarVisible: false };

  componentDidMount() {
    this.props.fetchUser();
  }

  toggleVisibility = () => this.setState({ sidebarVisible: !this.state.sidebarVisible });

  render() {
    return (
      <div className="full-height">
        <BrowserRouter>
          <Sidebar.Pushable className="full-height">
            <Sidebar
              as={Menu}
              animation="push"
              width="thin"
              visible={this.state.sidebarVisible}
              icon="labeled"
              vertical
              inverted
            >
              <Link to="/home">
                <Menu.Item name="home">
                  <Icon name="home" />
                  Início
                </Menu.Item>
              </Link>
              <Link to="/search">
                <Menu.Item name="search">
                  <Icon name="search" />
                  Busca
                </Menu.Item>
              </Link>
              <Link to="/saved">
                <Menu.Item name="folder outline">
                  <Icon name="folder outline" />
                  Coleção
                </Menu.Item>
              </Link>
            </Sidebar>
            <Sidebar.Pusher className="full-height">
              <Container fluid style={{ padding: 30 }}>
                <div className="full-height">
                  <div>
                    <Header>
                      <Button
                        id="sidebar-toggle-btn"
                        basic
                        floated="left"
                        icon="content"
                        onClick={this.toggleVisibility}
                      />
                    </Header>
                  </div>
                  <Route exact path="/" component={Landing} />
                  <Route path="/home" component={Home} />
                  <Route path="/search" component={Search} />
                  <Route path="/saved" component={Saved} />
                </div>
              </Container>
            </Sidebar.Pusher>
          </Sidebar.Pushable>
        </BrowserRouter>
      </div>
    );
  }
}

App.propTypes = {
  fetchUser: PropTypes.func,
};

export default connect(
  null,
  actions,
)(App);



// WEBPACK FOOTER //
// ./src/components/App.js